export enum CountrySortType {
    Id,
    Name,
    IsDeleted
}
